import { render, staticRenderFns } from "./zhiShiYaoDian.vue?vue&type=template&id=5fc60e98&scoped=true&"
import script from "./zhiShiYaoDian.vue?vue&type=script&lang=js&"
export * from "./zhiShiYaoDian.vue?vue&type=script&lang=js&"
import style0 from "./zhiShiYaoDian.vue?vue&type=style&index=0&id=5fc60e98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc60e98",
  null
  
)

export default component.exports